import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-xl-8" }
const _hoisted_2 = { class: "card-header d-block pb-2" }
const _hoisted_3 = { class: "d-flex align-items-center my-3" }
const _hoisted_4 = { class: "m-0 fs-5 me-3" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "m-0 fs-5 me-3" }
const _hoisted_8 = { class: "d-flex align-items-center ms-5" }
const _hoisted_9 = { class: "d-flex align-items-center ms-5" }
const _hoisted_10 = { class: "d-flex align-items-center ms-5" }
const _hoisted_11 = { class: "d-flex align-items-center mt-3" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "d-flex align-items-center ms-5" }
const _hoisted_14 = { class: "d-flex align-items-center ms-5" }
const _hoisted_15 = { class: "d-flex align-items-center ms-5" }
const _hoisted_16 = { class: "d-flex align-items-center ms-5" }
const _hoisted_17 = { class: "d-flex align-items-center ms-5" }
const _hoisted_18 = { class: "d-flex align-items-center ms-5" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "text-end w-100 mb-4 d-flex align-items-center justify-content-between gap-1" }
const _hoisted_21 = { class: "fw-bold fs-4" }
const _hoisted_22 = { class: "d-flex align-items-center gap-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-dot text-success" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-dot text-danger" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-vial text-danger m-1" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-file text-primary m-1" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-paste text-gray" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-comment-dots text-primary" }, null, -1)
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_32 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_33 = {
  class: "table align-middle table-row-dashed fs-6 gy-1 table-hover",
  id: "table_accounts_requests"
}
const _hoisted_34 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", { class: "" }, null, -1)
const _hoisted_36 = { class: "" }
const _hoisted_37 = { class: "" }
const _hoisted_38 = { class: "" }
const _hoisted_39 = {
  key: 0,
  class: ""
}
const _hoisted_40 = {
  key: 1,
  class: ""
}
const _hoisted_41 = {
  key: 2,
  class: ""
}
const _hoisted_42 = { class: "" }
const _hoisted_43 = { class: "" }
const _hoisted_44 = { class: "" }
const _hoisted_45 = {
  key: 3,
  class: ""
}
const _hoisted_46 = {
  key: 4,
  class: ""
}
const _hoisted_47 = { class: "" }
const _hoisted_48 = { class: "" }
const _hoisted_49 = { class: "" }
const _hoisted_50 = { class: "" }
const _hoisted_51 = { class: "" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = {
  key: 2,
  class: "fw-semibold"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 0,
  class: "fa-solid fa-vial text-danger m-1"
}
const _hoisted_58 = {
  key: 1,
  class: "fa-regular fa-file text-primary m-1"
}
const _hoisted_59 = ["title"]
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { key: 2 }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_65 = {
  key: 1,
  class: "fa-regular fa-comment-dots text-secondary"
}
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "d-flex align-items-center gap-1" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_70 = {
  key: 1,
  class: "fa-regular fa-comment-dots text-secondary"
}
const _hoisted_71 = {
  key: 1,
  class: "fa-solid fa-circle-dot text-danger"
}
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_74 = {
  key: 1,
  class: "fa-regular fa-comment-dots text-secondary"
}
const _hoisted_75 = { key: 3 }
const _hoisted_76 = { key: 4 }
const _hoisted_77 = { class: "d-flex" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["innerHTML"]
const _hoisted_80 = ["innerHTML"]
const _hoisted_81 = { class: "d-flex justify-content-start align-items-center gap-2" }
const _hoisted_82 = { class: "me-1" }
const _hoisted_83 = { key: 1 }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}

import { useStore } from "@/store";
import {
  computed,
  inject,
  nextTick,
  onMounted,
  provide,
  ref,
  watch,
} from "vue";
import OpenProcedureForm from "../components/OpenProcedureForm.vue";
import i18n from "@/core/plugins/i18n";
import TableFooter from "@/components/TableFooter.vue";
import AccountDetail from "../components/AccountDetail.vue";
import GlobalService from "@/projects/client/services/ClientGlobalService";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
import { ServiceMapType } from "@/core/types/ServiceTypes";
import {
  ArrowDown,
  Search,
  Avatar,
  WarningFilled,
} from "@element-plus/icons-vue";
import CommentsView from "@/projects/tenant/components/CommentView.vue";
import { CommentType } from "@/core/types/CommentType";
import TimeShow from "@/components/TimeShow.vue";
import InjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import { PublicSetting } from "@/core/types/ConfigTypes";
import { useRoute, useRouter } from "vue-router";
import {
  AccountRoleTypes,
  AccountStatusTypes,
} from "@/core/types/AccountInfos";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import { SiteTypes } from "@/core/types/SiteTypes";
import AccountService, {
  generateAutoCompleteHandler,
} from "@/projects/tenant/modules/accounts/services/AccountService";
import { AccountGroupTypes } from "@/core/types/AccountGroupTypes";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import TinyCopyBox from "@/components/TinyCopyBox.vue";
import ViewReferPath from "@/projects/tenant/modules/accounts/components/modal/ViewReferPath.vue";
import ChangeCreditForm from "@/projects/tenant/modules/Payment/components/ChangeCreditForm.vue";
import ChangeAdjustForm from "@/projects/tenant/modules/Payment/components/ChangeAdjustForm.vue";
import SearchHistory from "@/projects/tenant/components/SearchHistory.vue";
import ExportAccounts from "../components/modal/ExportAccounts.vue";
import TagSelector from "@/projects/tenant/components/TagSelector.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountClients',
  setup(__props) {

const { t } = i18n.global;
const route = useRoute();
const router = useRouter();
const store = useStore();
const tenant = ref(store.state.AuthModule.user?.tenancy);
const queryAgentGroupAsync = generateAutoCompleteHandler(
  async (keywords: string) => {
    const res = await AccountService.getFullAccountGroupNames(
      AccountGroupTypes.Agent,
      keywords
    );
    return res.map((item) => ({ value: item, label: item }));
  }
);

const querySalesGroupAsync = generateAutoCompleteHandler(
  async (keywords: string) => {
    const res = await AccountService.getFullAccountGroupNames(
      AccountGroupTypes.Sales,
      keywords
    );
    return res.map((item) => ({ value: item, label: item }));
  }
);

const projectConfig = computed<PublicSetting>(
  () => store.state.AuthModule.config
);
const ServiceList = ref<any>([
  { label: "-- All --", value: "" },
  { label: "No Server", value: 0 },
  { label: "BCRCO-Real", value: 10 },
  { label: "BCR-Real", value: 20 },
  { label: "BCR-MT5", value: 30 },
]);

const getInitialCriteria = () => ({
  page: 1,
  size: 20,
  ServiceId:
    {
      mt4: 20,
      mt5: 30,
    }[route.params.type as string] ?? undefined,
  includeClosed: false,
  sortField: "CreatedOn",
});

const criteria = ref<any>(getInitialCriteria());
const accountDetailRef = ref<InstanceType<typeof AccountDetail>>();
const changeCreditFormRef = ref<InstanceType<typeof ChangeCreditForm>>();
const changeAdjustFormRef = ref<InstanceType<typeof ChangeAdjustForm>>();
const commentsRef = ref<any>(null);
const exportAccountsRef = ref<any>(null);
const SearchHistoryRef = ref<InstanceType<typeof SearchHistory>>();

const openProcedureFormRef = ref<InstanceType<typeof OpenProcedureForm>>();

const isLoading = ref(true);
const liveAccounts = ref(Array<any>());
const serviceMap = ref<ServiceMapType>({} as ServiceMapType);

const isSearch = ref(false);
const searchTrigger = ref(false);

const accountSelected = ref(0);
const createdAtRange = ref<any>(null);
const selectedTags = ref<string[]>([]);

const handleOpenUserDetail =
  inject(InjectionKeys.OPEN_USER_DETAILS) ?? ((any) => null);

provide(AccountInjectionKeys.HANDLE_REFRESH_ACCOUNT_CLIENT_TABLE, () =>
  fetchData(criteria.value.page)
);

const handleOpenAccountProcedure = (item, step?) => {
  /**
   * {
   *   "welcomeEmailSent": false,
   *   "noticeEmailSent": false
   *   "kycFormCompleted": false,
   *   "paymentAccessGranted": false,
   * }
   */
  openProcedureFormRef.value?.show(step ?? -1, { accountDetails: item });
};

const createKYCFromOpenAccountProcedure = (item) => {
  openProcedureFormRef.value?.show(4, { accountDetails: item });
};

const handleResearch = (text) => {
  console.log("reSearch", text);
  criteria.value.searchText = text;
  fetchData(1);
};

const paymentServiceCriteria = ref({
  size: 100,
});

const clearSearchFilterCriteria = async () => {
  criteria.value = getInitialCriteria();
  criteria.value.from = null;
  criteria.value.to = null;
  createdAtRange.value = null;
  selectedTags.value = [];
  await fetchData(1);
};

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  await nextTick();
  if (isSearch.value) {
    searchTrigger.value = !searchTrigger.value;
    await nextTick();
    return;
  }
  if (criteria.value.searchText) {
    SearchHistoryRef.value?.updateSearchHistory(criteria.value.searchText);
  }

  // Handle relativeLevel logic
  // DirectLevel: ParentAccountUid + RelativeLevel = 1
  // AllLevel: Default (no relativeLevel), optional ParentAccountUid
  if (criteria.value.parentAccountUid && criteria.value.level === 1) {
    // Direct Level: query next level of specific UID
    criteria.value.relativeLevel = 1;
  } else {
    // All Levels: query all data (with or without ParentAccountUid)
    criteria.value.relativeLevel = null;
  }

  // Add selected tags to criteria as TagNames (supports repeated params)
  if (selectedTags.value.length > 0) {
    // API expects TagNames=... (can be repeated)
    criteria.value.TagNames = selectedTags.value;
    // remove any legacy key
    delete criteria.value.tags;
  } else {
    delete criteria.value.TagNames;
    delete criteria.value.tags;
  }

  try {
    isLoading.value = true;
    const responseBody = await AccountService.queryAccounts(criteria.value);
    // Preserve the level value from frontend before overwriting with backend response
    const preservedLevel = criteria.value.level;
    const preservedTags = selectedTags.value; // Preserve selected tags
    criteria.value = responseBody.criteria;
    criteria.value.level = preservedLevel;

    // Clean up any backend-returned tag fields to prevent duplication
    delete criteria.value.tagNames;
    delete criteria.value.tags;

    // Restore TagNames from selectedTags (not from backend response)
    if (preservedTags.length > 0) {
      criteria.value.TagNames = preservedTags;
    } else {
      delete criteria.value.TagNames;
    }

    liveAccounts.value = responseBody.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};

watch(createdAtRange, (val) => {
  if (val && val.length === 2) {
    criteria.value.from = `${val[0]}T00:00:00.000Z`;
    criteria.value.to = `${val[1]}T23:59:59.999Z`;
  } else {
    criteria.value.from = null;
    criteria.value.to = null;
  }
});

watch(
  () => criteria.value.parentAccountUid,
  (newVal) => {
    // Reset level to All Levels when parentAccountUid is cleared
    if (!newVal) {
      criteria.value.level = null;
    }
  }
);

watch(selectedTags, () => {
  fetchData(1);
});

watch(
  () => route.params.type,
  () => {
    criteria.value = getInitialCriteria();
    fetchData(1);
  }
);

onMounted(async () => {
  serviceMap.value = await GlobalService.getServiceMap();
  criteria.value = getInitialCriteria();
  await fetchData(1);
  processActionByRoute();
});

const processActionByRoute = () => {
  if (!route.query) return;

  const action = route.query.action as string;
  const _handler = {
    checkRebate: () => {
      const _id = Number(route.query.accountId);
      showAccountDetail(_id, "rebate");
    },
  }[action];

  if (_handler) {
    _handler();
    setTimeout(() => router.push({ name: "accountClients" }), 5000);
  }
};

const viewComments = (type: CommentType, id: number, title: string) => {
  commentsRef.value?.show(type, id, title);
};
const showAccountDetail = (id: number, _tab = "infos") => {
  accountDetailRef.value?.show(id, _tab, [] as any);
};

const openChangeCreditPanel = (accountNumber: number) => {
  changeCreditFormRef.value?.show(accountNumber);
};
const openChangeAdjustPanel = (accountNumber: number) => {
  changeAdjustFormRef.value?.show(accountNumber);
};

const showExportPanel = () => {
  exportAccountsRef.value?.show(criteria.value);
};

const handleGodModeClick = UserService.generateGodModeHandler();

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_AccountStatusBadge = _resolveComponent("AccountStatusBadge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("action.search")) + ":", 1),
        _createVNode(_component_el_input, {
          class: "w-400px",
          modelValue: criteria.value.searchText,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.searchText) = $event)),
          clearable: true,
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: _unref(Search),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchData(1)))
            }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(SearchHistory, {
          category: "account",
          ref_key: "SearchHistoryRef",
          ref: SearchHistoryRef,
          onReSearch: handleResearch
        }, null, 512),
        _createVNode(TagSelector, {
          type: "account",
          modelValue: selectedTags.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedTags).value = $event)),
          class: "ms-3"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("action.filter")) + ":", 1),
          _createVNode(_component_el_checkbox, {
            class: "me-2",
            modelValue: criteria.value.includeClosed,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((criteria.value.includeClosed) = $event)),
            label: _unref(t)('status.showClosedAccount')
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_el_select, {
            class: "w-100px ms-2",
            modelValue: criteria.value.serviceId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((criteria.value.serviceId) = $event)),
            placeholder: "MT"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ServiceList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_select, {
            class: "w-100px ms-2",
            modelValue: criteria.value.status,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((criteria.value.status) = $event)),
            placeholder: _ctx.$t('fields.status')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "-- All --",
                value: ""
              }),
              _createVNode(_component_el_option, {
                label: "Activated",
                value: _unref(AccountStatusTypes).Activate
              }, null, 8, ["value"]),
              _createVNode(_component_el_option, {
                label: "Paused",
                value: _unref(AccountStatusTypes).Pause
              }, null, 8, ["value"]),
              _createVNode(_component_el_option, {
                label: "Inactivated",
                value: _unref(AccountStatusTypes).Inactivated
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_select, {
            class: "w-75px ms-2",
            modelValue: criteria.value.siteId,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((criteria.value.siteId) = $event)),
            placeholder: _ctx.$t('fields.site')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "-- All --",
                value: ""
              }),
              _createVNode(_component_el_option, {
                label: _ctx.$t(`type.siteType.${_unref(SiteTypes).Default}`),
                value: _unref(SiteTypes).Default
              }, null, 8, ["label", "value"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t(`type.siteType.${_unref(SiteTypes).BritishVirginIslands}`),
                value: _unref(SiteTypes).BritishVirginIslands
              }, null, 8, ["label", "value"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t(`type.siteType.${_unref(SiteTypes).Australia}`),
                value: _unref(SiteTypes).Australia
              }, null, 8, ["label", "value"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t(`type.siteType.${_unref(SiteTypes).China}`),
                value: _unref(SiteTypes).China
              }, null, 8, ["label", "value"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t(`type.siteType.${_unref(SiteTypes).Taiwan}`),
                value: _unref(SiteTypes).Taiwan
              }, null, 8, ["label", "value"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t(`type.siteType.${_unref(SiteTypes).Vietnam}`),
                value: _unref(SiteTypes).Vietnam
              }, null, 8, ["label", "value"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t(`type.siteType.${_unref(SiteTypes).Japan}`),
                value: _unref(SiteTypes).Japan
              }, null, 8, ["label", "value"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t(`type.siteType.${_unref(SiteTypes).BBL}`),
                value: _unref(SiteTypes).BBL
              }, null, 8, ["label", "value"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_select, {
            class: "w-100px ms-2",
            modelValue: criteria.value.currencyId,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((criteria.value.currencyId) = $event)),
            placeholder: _ctx.$t('fields.currency')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "-- All --",
                value: ""
              }),
              _createVNode(_component_el_option, {
                label: "USD",
                value: 840
              }),
              _createVNode(_component_el_option, {
                label: "AUD",
                value: 36
              }),
              _createVNode(_component_el_option, {
                label: "JPY",
                value: 392
              }),
              _createVNode(_component_el_option, {
                label: "USC",
                value: 841
              })
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_date_picker, {
            modelValue: createdAtRange.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((createdAtRange).value = $event)),
            type: "daterange",
            "start-placeholder": _ctx.$t('fields.startDate'),
            "end-placeholder": _ctx.$t('fields.endDate'),
            "value-format": "YYYY-MM-DD",
            class: "w-250px",
            clearable: ""
          }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_select, {
            class: "w-100px",
            modelValue: criteria.value.role,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((criteria.value.role) = $event)),
            placeholder: _ctx.$t('fields.role')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "-- All --",
                value: ""
              }),
              _createVNode(_component_el_option, {
                label: "Client",
                value: _unref(AccountRoleTypes).Client
              }, null, 8, ["value"]),
              _createVNode(_component_el_option, {
                label: "IB",
                value: _unref(AccountRoleTypes).IB
              }, null, 8, ["value"]),
              _createVNode(_component_el_option, {
                label: "Sales",
                value: _unref(AccountRoleTypes).Sales
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_input, {
            class: "w-150px",
            modelValue: criteria.value.parentAccountUid,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((criteria.value.parentAccountUid) = $event)),
            placeholder: "Child Accounts",
            clearable: "",
            onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_input, {
            class: "w-150px",
            modelValue: criteria.value.salesUid,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((criteria.value.salesUid) = $event)),
            placeholder: "Sales Child Only",
            clearable: "",
            onKeyup: _cache[14] || (_cache[14] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_autocomplete, {
            clearable: "",
            onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => (fetchData(1)), ["enter"])),
            class: "w-150px",
            modelValue: criteria.value.group,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((criteria.value.group) = $event)),
            "fetch-suggestions": _unref(queryAgentGroupAsync),
            placeholder: _ctx.$t('fields.ibGroup')
          }, null, 8, ["modelValue", "fetch-suggestions", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_autocomplete, {
            onKeyup: _cache[17] || (_cache[17] = _withKeys(($event: any) => (fetchData(1)), ["enter"])),
            clearable: "",
            class: "w-150px",
            modelValue: criteria.value.code,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((criteria.value.code) = $event)),
            "fetch-suggestions": _unref(querySalesGroupAsync),
            placeholder: _ctx.$t('fields.salesCode')
          }, null, 8, ["modelValue", "fetch-suggestions", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_select, {
            class: "w-150px",
            modelValue: criteria.value.level,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((criteria.value.level) = $event)),
            placeholder: "Level",
            disabled: !criteria.value.parentAccountUid
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('fields.allLevels'),
                value: null
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('fields.directLevel'),
                value: 1
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (fetchData(1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            plain: "",
            type: "primary",
            class: "",
            onClick: clearSearchFilterCriteria
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: showExportPanel,
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("title.total")) + ": " + _toDisplayString(criteria.value.total || 0), 1),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", null, [
            _hoisted_23,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("status.normal")) + " | ", 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_24,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("status.closed")) + " | ", 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_25,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("status.testAccount")) + " | ", 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_26,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("status.dailyReport")) + " | ", 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_27,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("action.copy")) + " | ", 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_28,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("status.hasComments")) + " | ", 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_el_icon, { color: "#FF0000" }, {
              default: _withCtx(() => [
                _createVNode(_unref(WarningFilled))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("title.cheaterIp")) + " | ", 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Avatar))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("status.blocked")) + " | ", 1)
          ]),
          (tenant.value != 'jp')
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createTextVNode(" © "),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.commission")), 1),
                _createTextVNode(" | ")
              ]))
            : _createCommentVNode("", true),
          (tenant.value != 'jp')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createTextVNode(" ℗ "),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("title.pips")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("table", _hoisted_33, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t("fields.status")), 1),
            _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t("fields.id")), 1),
            _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.$t("fields.type")), 1),
            (tenant.value != 'jp')
              ? (_openBlock(), _createElementBlock("th", _hoisted_39, _toDisplayString(_ctx.$t("fields.currency")), 1))
              : _createCommentVNode("", true),
            (tenant.value != 'jp')
              ? (_openBlock(), _createElementBlock("th", _hoisted_40, _toDisplayString(_ctx.$t("fields.wallet") + " ID"), 1))
              : _createCommentVNode("", true),
            (tenant.value != 'jp')
              ? (_openBlock(), _createElementBlock("th", _hoisted_41, "MT"))
              : _createCommentVNode("", true),
            _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.$t("fields.tradeAccount")), 1),
            _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.$t("fields.name")), 1),
            _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.$t("fields.email")), 1),
            (tenant.value != 'jp')
              ? (_openBlock(), _createElementBlock("th", _hoisted_45, _toDisplayString(_ctx.$t("fields.site")), 1))
              : _createCommentVNode("", true),
            (projectConfig.value.rebateEnabled && tenant.value != 'au')
              ? (_openBlock(), _createElementBlock("th", _hoisted_46, _toDisplayString(_ctx.$t("fields.rebate")), 1))
              : _createCommentVNode("", true),
            _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.$t("fields.group")), 1),
            _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.$t("fields.role")), 1),
            _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.$t("fields.sales")), 1),
            _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.$t("fields.ib")), 1),
            _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.$t("fields.created_at")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_52, [
              _createVNode(LoadingRing)
            ]))
          : (!isLoading.value && liveAccounts.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_53, [
                _createVNode(NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_54, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(liveAccounts.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: _normalizeClass({
              'text-gray-600': item.status === 1,
              'text-gray-400': item.status === 2,
              'account-select': item.id === accountSelected.value,
            }),
                    onClick: ($event: any) => (selectedAccount(item.id))
                  }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_dropdown, { trigger: "click" }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              (!item.wizzard?.paymentAccessGranted)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 0,
                                    onClick: ($event: any) => (handleOpenAccountProcedure(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("tip.accountOpenProcedure")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: ($event: any) => (handleOpenAccountProcedure(item, 3))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("tip.readOnlyNotice")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: ($event: any) => (handleOpenAccountProcedure(item, 4))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("tip.kycForm")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_dropdown_item, {
                                      onClick: ($event: any) => (handleOpenAccountProcedure(item, 5))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("title.paymentMethod")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    (tenant.value != 'au')
                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                          key: 0,
                                          onClick: ($event: any) => (handleOpenAccountProcedure(item, 6))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("title.rebate")), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ], 64)),
                              _createVNode(_component_el_dropdown_item, {
                                divided: "",
                                onClick: ($event: any) => (_unref(handleOpenUserDetail)(item.user?.partyId))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("title.userDetails")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, {
                                divided: "",
                                onClick: ($event: any) => (showAccountDetail(item.id, 'infos'))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("title.accountDetails")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (showAccountDetail(item.id, 'trade'))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("title.tradeHistory")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (showAccountDetail(item.id, 'transaction'))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("title.transferHistory")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (showAccountDetail(item.id, 'deposit'))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("title.deposit")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (showAccountDetail(item.id, 'withdraw'))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("title.withdrawal")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              (
                        (item.role == 400 || item.role == 300) &&
                        tenant.value != 'jp' &&
                        tenant.value != 'au'
                      )
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 2,
                                    onClick: ($event: any) => (showAccountDetail(item.id, 'rebate'))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("title.rebate")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: ($event: any) => (showAccountDetail(item.id, 'paymentMethod'))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("title.paymentMethod")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              (item.role == 400)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 3,
                                    divided: "",
                                    onClick: ($event: any) => (openChangeCreditPanel(item.accountNumber))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("action.changeCredit")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (item.role == 400)
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 4,
                                    onClick: ($event: any) => (openChangeAdjustPanel(item.accountNumber))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("action.changeAdjust")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (item.role == 400 && tenant.value != 'jp')
                                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: 5,
                                    onClick: ($event: any) => (createKYCFromOpenAccountProcedure(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("action.generateKyc")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            class: "btn btn-secondary btn-sm"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.action")), 1),
                              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ArrowDown))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("td", {
                      onClick: ($event: any) => (_unref(handleGodModeClick)(item.partyId))
                    }, [
                      _createVNode(_component_AccountStatusBadge, {
                        status: item.status,
                        showDot: true
                      }, null, 8, ["status"]),
                      (item.accountTags.includes('Test'))
                        ? (_openBlock(), _createElementBlock("i", _hoisted_57))
                        : _createCommentVNode("", true),
                      (item.accountTags.includes('DailyConfirmEmail'))
                        ? (_openBlock(), _createElementBlock("i", _hoisted_58))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_56),
                    _createElementVNode("td", {
                      title: `${item.id} (${item.partyId})`
                    }, [
                      _createTextVNode(_toDisplayString(item.uid), 1),
                      _createVNode(TinyCopyBox, {
                        class: "p-1",
                        val: item.uid.toString()
                      }, null, 8, ["val"])
                    ], 8, _hoisted_59),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.shortAccount.${item.type}`)), 1),
                    (tenant.value != 'jp')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_60, _toDisplayString(_unref(t)(`type.currency.${item.currencyId}`)), 1))
                      : _createCommentVNode("", true),
                    (tenant.value != 'jp')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_61, _toDisplayString(item.walletId), 1))
                      : _createCommentVNode("", true),
                    (tenant.value != 'jp')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_62, _toDisplayString(serviceMap.value[item.serviceId]?.serverName), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(item.accountNumber), 1),
                      (item.accountNumber)
                        ? (_openBlock(), _createBlock(TinyCopyBox, {
                            key: 0,
                            val: item.accountNumber.toString()
                          }, null, 8, ["val"]))
                        : _createCommentVNode("", true),
                      (_ctx.$can('Admin'))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "ms-2 cursor-pointer",
                            role: "button",
                            onClick: ($event: any) => (
                  viewComments(_unref(CommentType).Account, item.id, item.accountNumber)
                )
                          }, [
                            (item.hasComment)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_64))
                              : (_openBlock(), _createElementBlock("i", _hoisted_65))
                          ], 8, _hoisted_63))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        role: "button",
                        onClick: ($event: any) => (
                  viewComments(
                    _unref(CommentType).User,
                    item.user.partyId,
                    item.user.firstName + ' ' + item.user.lastName
                  )
                )
                      }, [
                        _createElementVNode("div", _hoisted_67, [
                          _createTextVNode(_toDisplayString(item.user.firstName) + " " + _toDisplayString(item.user.lastName) + " ", 1),
                          (_ctx.$can('Admin'))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "ms-2 cursor-pointer",
                                role: "button",
                                onClick: ($event: any) => (
                      viewComments(
                        _unref(CommentType).User,
                        item.user?.partyId,
                        item.user?.firstName + ' ' + item.user?.lastName
                      )
                    )
                              }, [
                                (item.user?.hasComment)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_69))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_70))
                              ], 8, _hoisted_68))
                            : _createCommentVNode("", true),
                          (item.user.status == 2)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_71))
                            : _createCommentVNode("", true),
                          (item.isInIpBlackList)
                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                key: 2,
                                color: "#FF0000"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(WarningFilled))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (item.isInUserBlackList)
                            ? (_openBlock(), _createBlock(_component_el_icon, { key: 3 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Avatar))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_66)
                    ]),
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(item.user.email), 1),
                      _createVNode(TinyCopyBox, {
                        class: "p-1",
                        val: item.user.email
                      }, null, 8, ["val"]),
                      (_ctx.$can('Admin'))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "ms-2 cursor-pointer",
                            role: "button",
                            onClick: ($event: any) => (
                  viewComments(
                    _unref(CommentType).User,
                    item.user?.partyId,
                    item.user?.firstName + ' ' + item.user?.lastName
                  )
                )
                          }, [
                            (item.user?.hasComment)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_73))
                              : (_openBlock(), _createElementBlock("i", _hoisted_74))
                          ], 8, _hoisted_72))
                        : _createCommentVNode("", true)
                    ]),
                    (tenant.value != 'jp')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_75, _toDisplayString(_ctx.$t(`type.siteType.${item.siteId}`)), 1))
                      : _createCommentVNode("", true),
                    (projectConfig.value.rebateEnabled)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_76, [
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["text-uppercase me-1", { 'text-danger': !item.hasRebateRule }]),
                              onClick: ($event: any) => (showAccountDetail(item.id, 'rebate'))
                            }, _toDisplayString(item.hasRebateRule), 11, _hoisted_78),
                            _createElementVNode("span", {
                              innerHTML: 
                    item.accountTags.includes('AddCommission') == true
                      ? ' \&\#169'
                      : ''
                  
                            }, null, 8, _hoisted_79),
                            _createElementVNode("span", {
                              innerHTML: 
                    item.accountTags.includes('AddPips') == true
                      ? ' \&\#8471'
                      : ''
                  
                            }, null, 8, _hoisted_80)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_81, [
                        _createVNode(ViewReferPath, { item: item }, null, 8, ["item"]),
                        _createElementVNode("div", null, _toDisplayString(item.group), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.accountRole.${item.role}`)), 1),
                    _createElementVNode("td", null, [
                      (item.role === _unref(AccountRoleTypes).Sales)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", _hoisted_82, _toDisplayString(item.code), 1),
                            _createVNode(TinyCopyBox, {
                              val: item.code.toString()
                            }, null, 8, ["val"])
                          ], 64))
                        : (_openBlock(), _createElementBlock("span", _hoisted_83, [
                            _createElementVNode("span", {
                              role: "button",
                              onClick: ($event: any) => (
                    viewComments(
                      _unref(CommentType).Account,
                      item.salesAccount.id,
                      item.salesAccount.user.firstName +
                        ' ' +
                        item.salesAccount.user.lastName
                    )
                  )
                            }, [
                              _createTextVNode(" [" + _toDisplayString(item.salesAccount.code) + "] " + _toDisplayString(item.salesAccount.uid) + " ", 1),
                              (item.salesAccount.hasComment)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_85))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_84),
                            _createVNode(TinyCopyBox, {
                              val: item.salesAccount.uid.toString()
                            }, null, 8, ["val"])
                          ]))
                    ]),
                    _createElementVNode("td", null, [
                      (item.agentAccount.id == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_86, "No IB"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_87, [
                            _createElementVNode("span", {
                              role: "button",
                              onClick: ($event: any) => (
                    viewComments(
                      _unref(CommentType).Account,
                      item.agentAccount.id,
                      item.agentAccount.user.firstName +
                        ' ' +
                        item.agentAccount.user.lastName
                    )
                  )
                            }, [
                              _createTextVNode("[" + _toDisplayString(item.agentAccount.group) + "] " + _toDisplayString(item.agentAccount.uid) + " ", 1),
                              (item.agentAccount.hasComment)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_89))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_88),
                            _createVNode(TinyCopyBox, {
                              val: item.agentAccount.uid.toString()
                            }, null, 8, ["val"])
                          ]))
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ])
                  ], 10, _hoisted_55))
                }), 128))
              ]))
      ]),
      _createVNode(TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(AccountDetail, {
      ref_key: "accountDetailRef",
      ref: accountDetailRef
    }, null, 512),
    _createVNode(OpenProcedureForm, {
      ref_key: "openProcedureFormRef",
      ref: openProcedureFormRef
    }, null, 512),
    _createVNode(CommentsView, {
      ref_key: "commentsRef",
      ref: commentsRef,
      type: "",
      id: "0"
    }, null, 512),
    _createVNode(ChangeAdjustForm, {
      ref_key: "changeAdjustFormRef",
      ref: changeAdjustFormRef
    }, null, 512),
    _createVNode(ChangeCreditForm, {
      ref_key: "changeCreditFormRef",
      ref: changeCreditFormRef
    }, null, 512),
    _createVNode(ExportAccounts, {
      ref_key: "exportAccountsRef",
      ref: exportAccountsRef
    }, null, 512)
  ]))
}
}

})